/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_attributes_family = /** @type {(inputs: {}) => string} */ () => {
	return `Typ výrobku`
};

const da_attributes_family = /** @type {(inputs: {}) => string} */ () => {
	return `Produkttype`
};

const de_attributes_family = /** @type {(inputs: {}) => string} */ () => {
	return `Produkttyp`
};

const en_attributes_family = /** @type {(inputs: {}) => string} */ () => {
	return `Product type`
};

const es_attributes_family = /** @type {(inputs: {}) => string} */ () => {
	return `Tipo de producto`
};

const fr_attributes_family = /** @type {(inputs: {}) => string} */ () => {
	return `Type de produit`
};

const hu_attributes_family = /** @type {(inputs: {}) => string} */ () => {
	return `Termék Típusa`
};

const it_attributes_family = /** @type {(inputs: {}) => string} */ () => {
	return `Tipo di prodotto`
};

const nl_attributes_family = /** @type {(inputs: {}) => string} */ () => {
	return `Soort product`
};

const pl_attributes_family = /** @type {(inputs: {}) => string} */ () => {
	return `Rodzaj produktu`
};

const pt_attributes_family = /** @type {(inputs: {}) => string} */ () => {
	return `Tipo de produto`
};

const sv_attributes_family = /** @type {(inputs: {}) => string} */ () => {
	return `Typ av produkt`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const attributes_family = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.attributes_family(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("attributes_family", locale)
	if (locale === "cs") return cs_attributes_family(inputs)
	if (locale === "da") return da_attributes_family(inputs)
	if (locale === "de") return de_attributes_family(inputs)
	if (locale === "en") return en_attributes_family(inputs)
	if (locale === "es") return es_attributes_family(inputs)
	if (locale === "fr") return fr_attributes_family(inputs)
	if (locale === "hu") return hu_attributes_family(inputs)
	if (locale === "it") return it_attributes_family(inputs)
	if (locale === "nl") return nl_attributes_family(inputs)
	if (locale === "pl") return pl_attributes_family(inputs)
	if (locale === "pt") return pt_attributes_family(inputs)
	return sv_attributes_family(inputs)
};
export { attributes_family as "attributes.family" }